import { createContext, useContext, useEffect, useState } from "react";

const LangCtx = createContext({ lang: "en", setLang: () => {} });

export const LanguageProvider = ({ children }) => {
    const [lang, setLangState] = useState(() => {
        if (typeof window === "undefined") return "en";
        const saved = window.localStorage.getItem("pck_lang");
        return saved === "es" || saved === "en" ? saved : "en";
    });

    const setLang = (next) => {
        setLangState(next);
        try {
            window.localStorage.setItem("pck_lang", next);
        } catch (_e) {
            /* ignore */
        }
    };

    useEffect(() => {
        document.documentElement.lang = lang;
    }, [lang]);

    return <LangCtx.Provider value={{ lang, setLang }}>{children}</LangCtx.Provider>;
};

export const useLang = () => useContext(LangCtx);
